import React from "react";
import Button from "./Button";
import { useState } from "react";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";
import { MdClose } from "react-icons/md";

const SignUpSection = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLoginFormSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    toggleModal(); // Add your logic for handling form submission here
  };
  return (
    <div className="container flex flex-wrap items-center justify-center">
      {/* Description Section */}
      <div className="w-full mb-4 lg:w-6/12 lg:px-4">
        <h4 className="mb-4 text-xl font-black">
          Join us today to stay ahead of the curve with the latest updates on
          your favorite
          <span className="mx-2 italic font-black text-transparent animate-text bg-gradient-to-r from-blue-500 via-cyan-500 to-violet-500 bg-clip-text">
            cryptocurrencies.
          </span>
        </h4>
        <p className="text-sm">
          By signing up, you'll have the freedom to monitor your investments at
          any time. Don't miss out—register now to take control of your
          financial future!
        </p>
      </div>

      {/* Form Section */}
      <div className="relative w-full px-4 md:w-6/12 xl:w-6/12">
        <form className="mt-4 md:mt-0" onSubmit={handleLoginFormSubmit}>
          <div className="relative max-w-xl mx-auto">
            <div className="absolute inset-0 transform -skew-y-6 shadow-lg bg-gradient-to-r from-blue-300 via-violet-300 to-blue-500 rounded-3xl sm:skew-y-3 -rotate-6"></div>
            <div className="relative z-10 px-4 py-10 bg-white shadow-[5px_2px_10px_grey] rounded-3xl md:p-14">
              <div>
                <h1 className="mb-8 text-2xl font-semibold text-center">
                  Login or Sign Up!
                </h1>
              </div>
              <div className="divide-y divide-blue-200">
                <div className="py-4 space-y-4 text-base leading-7 text-blue-500 sm:text-lg">
                  <div className="relative">
                    <input
                      autoComplete="off"
                      name="email"
                      type="text"
                      className="w-full h-10 text-gray-900 placeholder-transparent border-b-2 border-gray-300 peer focus:outline-none focus:border-blue-500"
                      placeholder="Email address"
                    />
                    <label
                      htmlFor="email"
                      className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                    >
                      Email Address
                    </label>
                  </div>

                  <div className="relative">
                    <input
                      autoComplete="off"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      className="w-full h-10 text-gray-900 placeholder-transparent border-b-2 border-gray-300 peer focus:outline-none focus:border-blue-500"
                      placeholder="Password"
                    />
                    <label
                      htmlFor="password"
                      className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                    >
                      Password
                    </label>
                    <div
                      className="absolute bottom-0 right-0 transform -translate-y-1/2 cursor-pointer"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <HiOutlineEye /> : <HiOutlineEyeOff />}
                    </div>
                  </div>

                  <div className="flex flex-col space-y-3">
                    <Button onClick={toggleModal}>Log in</Button>
                    <a href="#!" className="text-center underline">
                      Forgot password?
                    </a>
                  </div>

                  {modal && (
                    <div
                      className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50"
                      onClick={toggleModal}
                    >
                      <div className="bg-white p-6 rounded-md relative shadow-2xl">
                        <button
                          className="absolute top-0 right-0 mt-2 mr-2 text-blue-500 cursor-pointer"
                          onClick={toggleModal}
                        >
                          <MdClose />
                        </button>
                        <h2 className="text-2xl font-semibold mb-4">
                          Feature Coming Soon
                        </h2>
                        <p className="text-slate-800 font-medium">
                          This feature will be available in later updates. Stay
                          tuned and enjoy our frontend for now!
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpSection;
